<template>
  <div id="app">
    <router-view/>                                                        
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    console.log(this,567)
  },
}
</script>

<style>
	/* 单行超出隐藏 */
	.text_com {
		display: block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue